// @flow

import { type IncomingPayment } from './types';

export function getCurrencyExt(incomingPayment: IncomingPayment): string {
  if (incomingPayment.v2 && incomingPayment.v2.currency)
    return incomingPayment.v2.currency.ext;

  return '';
}
